import React, { useState } from 'react';
import Layout from '../../components/Layout/Layout';
import SettingsTab from './SettingsTab';
import CheckoutMessageTab from './CheckoutMessageTab';

const Settings: React.FC = () => {
    const [activeTab, setActiveTab] = useState<string>('settings');

    return (
        <Layout>
            <div className="d-flex justify-content-between align-items-start mb-4">
                <h1 className="app-page-title">Settings</h1>
            </div>

            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'settings' ? 'active' : ''}`}
                        onClick={() => setActiveTab('settings')}
                        type="button"
                    >
                        Settings
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'checkoutMessage' ? 'active' : ''}`}
                        onClick={() => setActiveTab('checkoutMessage')}
                        type="button"
                    >
                        Checkout Message
                    </button>
                </li>
            </ul>

            {activeTab === 'settings' && <SettingsTab />}
            {activeTab === 'checkoutMessage' && <CheckoutMessageTab />}
        </Layout>
    );
};

export default Settings;